import Loading from './src/Loading.js'

Loading.install = Vue => {
  Vue.prototype.$Loading = Loading
}

// eslint-disable-next-line import/no-default-export
export default Loading
